/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import JsBarcode from "jsbarcode";
import CommonButtons from "../shared/components/CommonButtons";
import { useUser } from "src/business-types/grocery/components/UserContext";
import noImage from "src/assets/Images/imetanic-logo.png";
import { Button } from "src/business-types/grocery/components/Button";
import { formatTerms, LABELS, ThermalPrinterTestProps } from "./PrintConfigration";

const ThermalPrint3: React.FC<ThermalPrinterTestProps> = ({
  PrintData,
  BtnName,
  openPrint,
  isClosed,
  ledgerPaid,
  barcodeTrue,
  icon,
  className,
  handleAppPrint,
  printerCheck,
}) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [barcodeDataUrl, setBarcodeDataUrl] = useState<string>("");
  const { user, userConfigration } = useUser();
  const comLogo = user?.companyLogo;

  const roundAmount = (value: any): string => {
    if (value === undefined || value === null || value === "") return "0.00";
    const num = Number(value);
    if (isNaN(num)) return "0.00";
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  const formatNumber = (value: number) => {
    return value < 1000 ? value.toString().padStart(4, "0") : value.toString();
  };

  const toBoolean = (value: any) => value === true || value === "true";
  const deliveryFeeEnabled = toBoolean(userConfigration?.deliveryFeeEnabled);
  const billNoEnabled = toBoolean(userConfigration?.billNoEnabled);
  const orderIdEnabled = userConfigration?.orderIdEnabled !== undefined ? toBoolean(userConfigration?.orderIdEnabled) : true;

  const formatCurrencyWithSign = (amount?: number | string) => {
    if (amount === undefined || amount === null) return "";

    const num = Number(amount);
    const sign = num < 0 ? "-" : "";
    const value = Math.abs(num);

    const rounded = Math.round((value + Number.EPSILON) * 100) / 100;

    return `${sign} ر.ق ${rounded.toFixed(2)}`;
  };

  const printHistory = () => {
    if (!PrintData?.payMentHistory || PrintData.payMentHistory.length === 0) return "";
    return `
      <div style="margin-top: 8px; border-top: 1px dashed #000; padding-top: 5px;">
        <div style="font-weight:bold; text-align:center; margin-bottom:5px;">Payment History</div>
        <table style="width:100%;">
          <thead>
            <tr style="border-bottom:1px dashed #000;">
              <th style="text-align:left;">Date</th>
              <th style="text-align:center;">Method</th>
              <th style="text-align:right;">Received</th>
              <th style="text-align:right;">Bal</th>
            </tr>
          </thead>
          <tbody>
            ${PrintData.payMentHistory
        .map(
          (p) => `
              <tr>
                <td>${p.date ?? p.payment_on}</td>
                <td style="text-align:center;">${p.Paymentmethod}</td>
                <td style="text-align:right;">${roundAmount(p.ReceivedAmount)}</td>
                <td style="text-align:right;">${p.balance ? roundAmount(p.balance) : "-"}</td>
              </tr>`,
        )
        .join("")}
          </tbody>
        </table>
      </div>
    `;
  };

  const ledgerList = () => {
    if (!ledgerPaid) return "";
    return `
    <div style="width:100%">
      <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
      <div style="display:flex; justify-content:space-between;">
        <div>Cus.Name : ${ledgerPaid?.CustomerName}</div>
        ${billNoEnabled
        ? ` <div>
                  Bill No: 
                  ${ledgerPaid?.billNo ? `${formatNumber(ledgerPaid?.billNo)}` : ""}
                  
                </div>`
        : ""
      } 
      </div>
        <div style="display:flex; justify-content:space-between;">
          <div>Cus.Phone: ${ledgerPaid?.CustomerPhon}</div>
          ${ledgerPaid?.clientId ? `<div>Client ID: ${ledgerPaid?.clientId}</div>` : ""}
        </div>
      </div>

      <div style="border-bottom: 1px dashed #000; margin-bottom: 5px; padding-bottom: 3px;">
        <div style="display:flex; justify-content:space-between;">
          <div>${LABELS.paymentType}:${ledgerPaid?.paymentMethod ?? ""}</div>
        </div>
        <div style="display:flex; justify-content:space-between;">
          <div>Date: ${ledgerPaid?.Date ?? ""} </div> 
          <div>Time: ${ledgerPaid?.Time ?? ""}</div>
        </div>
      </div>
      
      <div style="width: 100%; padding-bottom:6px;">
       <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          Prev. Balance (المبلغ المتبقي): ${roundAmount(ledgerPaid?.Balance)} ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          Balance Paid (مدفوع): ${roundAmount(Number(ledgerPaid?.Paid) || 0)} ر.ق
        </p>
        <p style="display: flex; justify-content: space-between; width: 98%; margin:0;">
          New Balance (المبلغ المتبقي): ${roundAmount(ledgerPaid?.Balance - Number(ledgerPaid?.Paid))} ر.ق
        </p>
      </div>
    </div>
   `;
  };

  /** ===============================
   * Customer CONTENT
   * =============================== */

  const customerData = () => {
    return `
    <div style="border-bottom: 1px solid black; margin-bottom: 5px; padding-bottom: 3px; display: flex; flex-direction: column; gap: 1px;">
      <div>${LABELS.customerName} : ${PrintData?.CustomerName ?? ""}</div>
      <div>${LABELS.customerPhone} : ${PrintData?.CustomerPhon ?? ""}</div> 
      ${PrintData?.clientId ? `<div>${LABELS.clientId} : ${PrintData.clientId}</div>` : ""}
    </div>`;
  };

  /** ===============================
   * Order CONTENT
   * =============================== */
  const orderData = () => {
    const billNoHtml = billNoEnabled && PrintData?.billNo ? `<div><strong>${LABELS.billNo}</strong> : ${formatNumber(PrintData.billNo)}</div>` : "";
    const orderIdHtml = orderIdEnabled && PrintData?.OrderId ? `<div><strong>${LABELS.orderId}</strong> : ${PrintData?.OrderId}</div>` : "";

    return `
    <div style="border-bottom: 1px solid black; margin-bottom: 5px; padding-bottom: 3px; display: flex; flex-direction: column; gap: 1px;">
      ${orderIdHtml}
      ${billNoHtml}
      <div>${LABELS.date} : ${PrintData?.Time ?? ""} ${PrintData?.Date ?? ""}</div>
      <div>${LABELS.status} : ${PrintData?.OrderStatus ?? ""}</div>
      <div>${LABELS.paymentType} : ${PrintData?.paymentMethod ?? ""}</div>
    </div>`;
  };

  /** ===============================
   * Company CONTENT
   * =============================== */

  const companyData = (comLogo: any) => {
    console.log("user?.companyLogoAPP", user?.companyLogoAPP);
    return `
        <div style=" justify-content: center; align-items: center; border-bottom: 1px solid black; padding-bottom: 5px; margin-bottom: 5px;">
      <div style="flex: 1; text-align: center;">
        ${user?.companyLogoAPP
        ? `<img
         src="${user?.companyLogoAPP}"
         onerror="this.src=${noImage}"
         style="width: 200px; height: 200px; border-radius: 8px; object-fit: contain;"/>`
        : `<img src="${noImage}" style="width: 200px; height: 200px; border-radius: 8px; object-fit: contain;" />`
      }
      </div>
      <div style="flex: 2; text-align: center;">
        <h1 style="font-weight: bold; font-size: 20px;">${user?.organization_name}</h1>
        <h2 style="font-weight: bold; font-size: 24px;">${user?.organization_arabic_name}</h2>
        ${user?.business_location ? `<div>${user?.business_location}</div>` : ""}
        <div>Mob : ${user?.phone_number}</div>
      </div>
    </div>`;
  };

  /** ===============================
   * Company CONTENT
   * =============================== */

  const orderDetails = () => {
    return `
        
    <style>
      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        padding: 4px 2px;
        text-align: left;
      }

      /* Column Width Control */
      .col-no { width: 5%; }
      .col-name { width: 40%; }
      .col-qty { width: 25%; text-align: left; }
      .col-price { width: 15%; text-align: right; }
      .col-total { width: 15%; text-align: right; }

      /* Optional borders / spacing for rows */
      tr {
        padding-bottom: 4px;
      }
    </style>

    
    ${userConfigration.orderTableType === "Table Type:1" ? normalDesign() : ""}
    ${userConfigration.orderTableType === "Table Type:2" ? tailerShopOrderDetails() : ""}

    <div>
      <div style="display:flex; justify-content:space-between;"><span>${LABELS.subtotal}:</span> <span> ر.ق ${roundAmount(PrintData?.total)} </span></div>
      <div style="display:flex; justify-content:space-between;"><span>${LABELS.discount}:</span> <span> ر.ق ${roundAmount(PrintData?.discount)} </span></div>
      ${deliveryFeeEnabled && PrintData
        ? `
    <div style="display:flex; justify-content:space-between;">
      <span>${LABELS.deliveryFee}:</span>
      <span>ر.ق ${roundAmount(Number(PrintData.deliveryFee))}</span>
    </div>
  `
        : ""
      }


      <div style="display:flex; justify-content:space-between; font-weight:bold;"><span>${LABELS.total2}:</span> <span> ر.ق ${roundAmount(
        PrintData?.subtotal,
      )} </span></div>
      ${PrintData?.Tip
        ? ` <div style="display:flex; justify-content:space-between;"><span>Tip(نصيحة):</span> <span>${roundAmount(PrintData?.Tip)} </span></div>`
        : ""
      }
      <div style="display:flex; justify-content:space-between;"><span>${LABELS.paid}:</span> <span> ر.ق ${roundAmount(PrintData?.Paid)} </span></div>
      <div style="display:flex; justify-content:space-between;"><span>${LABELS.due}:</span> <span> ر.ق  ${roundAmount(
        PrintData?.unpaid,
      )} </span></div>
      ${PrintData?.OSB
        ? `<div style="display:flex; justify-content:space-between; border-top: 1px solid black; padding-top:5px;"><strong>${LABELS.outstanding
        }:</strong> <span dir="ltr">${formatCurrencyWithSign(PrintData?.OSB)}</span>`
        : ""
      }
    </div>`;
  };

  const tailerShopOrderDetails = () => {
    return `
    <div style = "border-bottom: 1px dashed #000;">
    <div style="font-weight:bold;">
     Iteams:
   </div>
    <hr/>

    ${PrintData?.Products?.map(
      (product, index) => `
   
   <div style="font-weight:bold;">
     ${index + 1}. ${product.productName}<br/>${product.arabicword ? `<span style="font-size: 10px; margin-left: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">${product.arabicword}</span>` : ""}
   </div>

   <div style="display:flex; justify-content:space-between;  padding-left:10px;">
     <div>
       ${product.quantity} ${product.uom || ""} X ${roundAmount(product.amount)}
     </div>
     <div>
       ${roundAmount(product.quantity * product.amount)}
     </div>
   </div>

   ${product.addOns && product.addOns.length > 0
          ? product.addOns
            .map(
              (s) => `
         <div style="display:flex; justify-content:space-between; font-size:12px; padding-left:10px;">
           <div>${s.text}</div>
           <div>${roundAmount(s.amount)}</div>
         </div>
       `,
            )
            .join("")
          : ""
        }

   <br/>
 `,
    ).join("")}
    </div>
    `;
  };

  const normalDesign = () => {
    return `
    <table style="width: 100%; border-collapse: collapse; margin-bottom: 5px; border-bottom: 1px dashed #000;">
      <thead style="border-bottom: 1px dashed #000;">
         <tr>
          <th class="col-no">#</th>
          <th class="col-name">Product Name</th>
          <th class="col-qty">Qty</th>
          <th class="col-price">Price</th>
          <th class="col-total">Total</th>
        </tr>
      </thead>
      <tbody>
        ${PrintData?.Products?.map(
      (p, index) => `
          <tr>
           <td class="col-no" style>${index + 1}</td>
              <td class="col-name">
              ${p.productName}
              <br/>
              <span style="font-size: 10px; font-style: italic; font-family: 'Tahoma', sans-serif;">
                ${p.arabicword ?? ""}
              </span>
            </td>
            <td class="col-qty">${p.quantity}${PrintData?.businessType === "Grocery" ? p.uom?.substring(0, 3).toLowerCase() : ""}</td>
            <td class="col-price">${roundAmount(p.amount)}</td>
            <td class="col-total">${roundAmount(p.totalPrice)}</td>
          </tr>
          ${p.addOns && p.addOns.length > 0
          ? p.addOns
            .map(
              (s, sIndex) => `
              
              <!-- SERVICE ROW -->
              <tr>
                <td></td>
                
                <td style="padding-left:20px;font-size:11px;">
                   ${sIndex + 1} ${s.text}
                </td>

                <td></td>

                <td style="font-size:11px;">
                  ${roundAmount(s.amount)}
                </td>

                <td style="font-size:11px;">
                  
                </td>
              </tr>
            `,
            )
            .join("")
          : ""
        }
        `,
    ).join("") || ""
      }
      </tbody>
    </table>`;
  };

  const carwashorderdetails = () => {
    const printDataAny = PrintData as any;
    const cars = printDataAny?.cars || [];
    const allProducts = PrintData?.Products || [];

    if (cars.length === 0 && allProducts.length === 0) {
      return "<div>No order data available</div>";
    }

    const formatPrice = (price: any) => {
      const num = Number(price);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    };

    let vehiclesCount = 0;
    let grandTotal = 0;

    /* ---------------- CARS ---------------- */
    const carsHtml = cars
      .map((car: any, index: number) => {
        vehiclesCount++;
        let carSubtotal = 0;

        const products = car?.services?.[0]?.productDetails || [];

        const productRows = products
          .map((product: any) => {
            const price = Number(product.price) || 0;
            carSubtotal += price;
            grandTotal += price;

            return `
            <div style="display:flex; justify-content:space-between; padding:4px 0;">
              <div>${product.product || ""}</div>
              <div>${formatPrice(price)}</div>
            </div>
          `;
          })
          .join("");

        return `
        <!-- Car Header -->
        <div style="
          background:#f1f5f9;
          padding:6px 10px;
          font-weight:600;
          margin:10px 0 6px;
           border:1px solid #cbd5e1;
        ">
          🚗 Car ${index + 1}: ${car.carNumber || `CAR-${index + 1}`}
        </div>

        <!-- Products -->
        ${productRows}

        <!-- Subtotal -->
        <div style="
          display:flex;
          justify-content:space-between;
          padding-top:6px;
          border-top:1px solid #e5e7eb;
          font-weight:600;
        ">
          <div>Car ${index + 1} Subtotal:</div>
          <div>${formatPrice(carSubtotal)} رق</div>
        </div>
      `;
      })
      .join("");

    return `
    <div style="
      font-family: Arial, sans-serif;
      font-size:12px;
      padding:12px;
    ">

      <!-- Title -->
      <div style="
        background:#1e293b;
        color:#fff;
        text-align:center;
        padding:8px;
        font-weight:700;
        border-radius:6px;
        margin-bottom:10px;
      ">
        MULTI-CAR ORDER - ${vehiclesCount} VEHICLES
      </div>

      <!-- Cars -->
      ${carsHtml}

      <!-- Summary -->
      <div style="border-top:1px solid #cbd5e1; margin:12px 0 6px;"></div>

      <div style="display:flex; justify-content:space-between; margin-bottom:4px;">
        <div>Vehicles:</div>
        <div>${vehiclesCount} cars</div>
      </div>

      <div style="
        display:flex;
        justify-content:space-between;
        font-weight:700;
        font-size:12px;
      ">
        <div>Total:</div>
        <div>${formatPrice(grandTotal)} رق</div>
      </div>

    </div>
  `;
  };

  const businessTypes = user?.business_type || "";


  const balanceCondent = () => {
    return `
    <div style="
      padding-top:4px;
      display:flex;
      justify-content:space-between;
      align-items:stretch;
      gap:10px;
      width:100%;
      text-align:center;
      border-bottom: 1px dashed black;
      border-top: 1px dashed black
      
    ">

      <div style="
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        align-items:center;
        gap:4px;
      ">
        <span style="
          font-weight:bold;
        ">
          Order Amount <br/>
          (المبلغ الإجمالي)
        </span>

        <span >
          ${roundAmount(PrintData?.total)} ر.ق
        </span>
      </div>

      <div style="
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        align-items:center;
        gap:6px;
      ">
        <span style="
          font-weight:bold;
        ">
          Total Paid <br/>
          (مدفوع)
        </span>

        <span >
          ${roundAmount(Number(PrintData?.resvedAmount) || 0)} ر.ق
        </span>
      </div>

      <div style="
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        align-items:center;
        gap:6px;
      ">
        <span style="
          font-weight:bold;
        ">
          Remaining Balance <br/>
          (المبلغ المتبقي)
        </span>

        <span >
          ${roundAmount(PrintData?.balanceReturned)} ر.ق
        </span>
      </div>

    </div>
  `;
  };

  /** ===============================
   * RECEIPT HTML CONTENT
   * =============================== */
  const content = `
  <div class="receipt-content" style="font-family: Arial, sans-serif; width: 100%; padding: 5px;">

    ${companyData(comLogo)}
    ${PrintData ? orderData() : ""}
    ${PrintData ? customerData() : ""}
    ${ledgerPaid ? ledgerList() : ""}
    ${PrintData ? (businessTypes === "Carwash" ? carwashorderdetails() : "") : ""}
    ${PrintData ? (businessTypes !== "Carwash" ? orderDetails() : "") : ""}
    ${PrintData?.balanceEnabiled ? balanceCondent() : ""}
    ${PrintData?.payMentHistoryAvabile ? printHistory() : ""}
    ${barcodeTrue ? `<div style="text-align:center; margin-top:10px;"><img src="${barcodeDataUrl}" style="width:200px; height:50px;" /></div>` : ""}
    ${userConfigration.enabileTermsAndConditions && userConfigration.termsAndConditionsEnglish ? `<div style="margin-top:10px; border-top:1px solid #e5e7eb;"><strong>Terms and Conditions:</strong><p>${formatTerms(userConfigration.termsAndConditionsEnglish)}</p></div>` : ""}
    ${userConfigration.enabileTermsAndConditions && userConfigration.termsAndConditionsArabic ? `<div style="margin-top:10px; font-size:14px;"><p>${formatTerms(userConfigration.termsAndConditionsArabic)}</p></div>` : ""}
    ${userConfigration?.contact_qr_codeAWS ? `<div style="text-align:center; margin-top:10px;"><strong>Contact QR Code:</strong><img src="${userConfigration.contact_qr_codeAWS}" style="width:160px; height:160px;" /></div>` : ""}
    ${userConfigration?.location_qr_codeAWS ? `<div style="text-align:center; margin-top:10px;"><strong>Location QR Code:</strong><img src="${userConfigration.location_qr_codeAWS}" style="width:160px; height:160px;" /></div>` : ""}
    <div style="text-align:center; margin-top:6px; border-top: 1px solid black; padding-top:5px;">
     <p>Thanks for visiting ${user?.organization_name || "iMetanic"}</p>
      <p>Powered by iMetanic</p>
    </div>

  </div>
  `;

  /**===============================
   * Print HTML STRUCTURE
   * =============================== */

  const copies = 1;

  const printData = `${printerCheck}
  <body>
  ${Array.from({ length: copies })
      .map(
        (_, index) => `
      <div class="page ${index < copies - 1 ? "copy-break" : ""}">
        ${content}
      </div>
    `,
      )
      .join("")}

</body>
</html>`;
  /** ===============================
   * PRINTING SYSTEM (AUTO PAPER SIZE)
   * =============================== */
  const handlePrint = () => {
    if (toBoolean(userConfigration.appPrinterEnabled) === true) {
      handleAppPrint?.(printData);
    } else {
      // alert("Please select a printer in the printer configuration to enable printing.");
      if (isDisabled) return;
      setIsDisabled(true);

      const iframe = document.createElement("iframe");
      iframe.style.position = "absolute";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      document.body.appendChild(iframe);

      const printDoc = iframe.contentWindow?.document;

      if (printDoc) {
        printDoc.open();
        printDoc.write(printData);
        printDoc.close();

        const cleanup = () => {
          try {
            if (document.body.contains(iframe)) document.body.removeChild(iframe);
          } catch (e) { }
          setIsDisabled(false);
        };

        iframe.onload = () => {
          try {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();
          } catch (e) { }

          const onAfterPrint = () => {
            try {
              isClosed?.(false);
            } catch (e) { }
            cleanup();
            try {
              iframe.contentWindow?.removeEventListener("afterprint", onAfterPrint);
            } catch (e) { }
          };

          try {
            iframe.contentWindow?.addEventListener("afterprint", onAfterPrint);
          } catch (e) { }

          setTimeout(() => {
            if (document.body.contains(iframe)) {
              try {
                isClosed?.(false);
              } catch (e) { }
              cleanup();
            }
          }, 2000);
        };
      }
    }
  };

  /** BARCODE GENERATION */
  useEffect(() => {
    if (PrintData?.OrderId) {
      const canvas = document.createElement("canvas");
      JsBarcode(canvas, String(PrintData.OrderId), {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: false,
      });
      setBarcodeDataUrl(canvas.toDataURL("image/png"));
    }
  }, [PrintData?.OrderId]);

  /** AUTO PRINT */
  useEffect(() => {
    if (!openPrint) return;
    // if barcode is expected, wait until it's generated
    if (barcodeTrue && !barcodeDataUrl) return;
    // If ledgerPaid is provided or PrintData is present, proceed
    handlePrint();
  }, [openPrint, barcodeDataUrl, barcodeTrue, ledgerPaid]);

  return (
    <div>
      {(BtnName || icon) &&
        (user?.business_type === "Grocery" ? (
          <Button className={className} label={BtnName} onClick={handlePrint} icon={icon} radius='rounded-full' font='font-bold' />
        ) : (
          <CommonButtons label={BtnName} onClick={handlePrint} icon={icon} className={className} />
        ))}
    </div>
  );
};

export default ThermalPrint3;
